<mat-toolbar color="accent" class="toolbar">
    <nav>
        <ng-container *ngFor="let screen of screens; trackBy: trackByScreen">
            <a 
                *ngIf="canAccessScreen(screen)" 
                mat-button
                [routerLink]="[screen | lowercase]"
                [routerLinkActive]="'nav-active'">
                {{ screen }}
            </a>
        </ng-container>
    </nav>
</mat-toolbar>